<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>

                <el-table
                        ref="table"
                        :data="dataList"
                        height="400"
                        style="width: 100%;"
                        highlight-current-row
                        :header-cell-style="headerStyle"
                        :cell-style="cellStyle"
                        row-key="id"
                        border>
                    <el-table-column
                            type="index"
                            label="序号"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="billType"
                            label="账单类别"
                            align="left"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="billDate"
                            label="账单日期"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="billNo"
                            label="账单编号"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="departmentNameUse"
                            label="领用单位"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                        prop="serialNo"
                        width="150"
                        label="系列号"
                        v-if="false">
                </el-table-column>
                    <el-table-column
                            prop="warehouseNo"
                            label="仓号"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="supplierName"
                            label="供应商"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="typeName"
                            label="物资分类"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="proCode"
                            label="物资编码"
                            align="left"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="proName"
                            label="物资名称"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="units"
                            label="计量单位"
                            align="center"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="origin"
                            label="产地"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="color"
                            label="颜色"
                            align="center"
                            width="100">
                    </el-table-column>

                    <el-table-column
                            prop="batch"
                            label="批次"
                            align="center"
                            width="100"
                            v-if="false">
                    </el-table-column>
                    <el-table-column
                            prop="validityDate"
                            label="有效期"
                            align="center"
                            width="100"
                            v-if="false">
                    </el-table-column>
                    <el-table-column
                            prop="manufacturer"
                            label="生产厂家/品牌"
                            align="center"
                            width="150"
                            v-if="false">
                    </el-table-column>
                    <el-table-column
                            prop="productDate"
                            label="生产日期"
                            align="center"
                            width="100"
                            v-if="false">
                    </el-table-column>

                    <el-table-column
                            prop="intoNum"
                            label="入库数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="intoPrice"
                            label="入库单价"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="intoTotal"
                            label="入库金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outNum"
                            label="出库数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outPrice"
                            label="出库单价"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outTotal"
                            label="出库金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endNum"
                            label="期末数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endPrice"
                            label="期末单价"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endTotal"
                            label="期末金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注"
                            align="center"
                            width="200">
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/statistics/billproflow/toolBar'

    export default {
        name: "billproflow",
        props: ['menuData'],
        components: {toolBar},
        data() {
            return {
                sumObject:{},
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false
            }
        },
        updated () {
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
        },
        methods: {
            async getListData() {

                if(this.searchData.formData.proCode==''){
                    this.$message({message: '请输入物资编码', type: 'error'});
                    return false;
                }

                if(this.searchData.formData.startDate==''){
                    this.$message({message: '请选择开始日期', type: 'error'});
                    return false;
                }

                this.loading = true;
                let param = {
                    url: "/billproductflow/list",
                    param: {
                        ...this.searchData.formData,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.data;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/billproductflow/excel",
                    param: {
                        ...this.searchData.formData,
                    }
                }

                this.$pub.openPostWindow(param);
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle({row}) {
                console.info("111"+row.billType)
                if (row.billType ==='合计') {
                    return "backgroundColor:#9cc7c5;text-align:center";
                }else {
                    return "text-align:center"
                }
            }
        }
    }
</script>
